<template>
  <div>
    <div class="col s12">
        <p>
            <ul class="tabs" ref="tabs">
                <li class="tab s6"><a class="active" href="#program">Description</a></li>
                <li class="tab s6"><a href="#sessions">Sessions</a></li>
            </ul>
        </p>
    </div>
    <div class="row" id="program">
      <div class="input-field col s6">
        <input id="program-key" v-model="program.name" type="text" class="validate" />
        <label for="program-key" class="active">Key</label>
      </div>
      <div class="input-field col s6">
        <input id="program-code" v-model="program.description.code" type="text" class="validate" />
        <label for="program-code" class="active">Code</label>
      </div>
      <div class="input-field col s12">
        <input id="program-name" v-model="program.description.name" type="text" class="validate" />
        <label for="program-name" class="active">Name</label>
      </div>
      <div class="input-field col s6">
        <input id="program-type" v-model="program.description.type" type="text" class="validate" />
        <label for="program-type" class="active">Type</label>
      </div>
      <div class="input-field col s6">
        <select id="program-intensity" v-model="program.description.intensity" class="browser-default">
          <option v-for="intensity in intensities" :key="intensity" :value="intensity">
            {{intensity}}
          </option>
        </select>
      </div>
    </div>
    
    <div class="row" id="sessions">
    <ul class="collapsible tasks" ref="collapsible">
        <li v-for="[name, session] in sortedSessions" :key="name">

            <div class="collapsible-header">
                {{name}} - {{session.title}}
            </div>
            <div class="collapsible-body">
               <div class="input-field col s12">
                  <input :id="'key-'+name" :value="name" type="text" class="validate" @change="onChangeSessionKey(name, session,$event)" />
                  <label :for="'key-'+name" class="active">Sequence</label>
                </div>
              <div class="row">
                  <div class="input-field col s12 m6">
                    <input :id="'title-'+name" v-model="session.title" type="text" class="validate" />
                    <label :for="'title-'+name" class="active">Session title</label>
                  </div>
              </div>
                <ul class="collection">
                  <li class="collection-item" v-for="(task, index)  in session.tasks" :key="index" >
                    <div v-if="task">
                      <div class="row">
                        <div class="col s3"><b>Task #{{index}}</b></div>
                        <div class="col s9">
                          <a @click="insertTask(session, task)"><i class="material-icons">add</i></a>
                          &nbsp;
                            <a @click="moveTaskUp(session, task)"><i class="material-icons">arrow_upward</i></a>
                            <a @click="moveTaskDown(session, task)"><i class="material-icons">arrow_downward</i></a>
                            &nbsp;
                            <a class="right" @click="removeTask(session, task)"><i class="material-icons">delete</i></a>

                        </div>
                      </div>
                      <div class="row">
                        <div class="input-field col s12 m6">
                          <input :id="'title-'+name+'-'+index" v-model="task.title" type="text" class="validate" />
                          <label :for="'title-'+name+'-'+index" class="active">Title</label>
                        </div>
                        <div class="input-field col s3">
                          <input :id="'capTime-'+name+'-'+index" v-model.number="task.capTime" type="text" class="validate" />
                          <label :for="'capTime-'+name+'-'+index" class="active">Cap</label>
                        </div>
                        <div class="input-field col s9">
                          <select :id="'type-'+name+'-'+index" v-model="task.type" class="browser-default">
                            <option v-for="type in taskTypes" :key="type.name" :value="type.name">
                              {{type.label}}
                            </option>
                          </select>
                        </div>
                        <div class="input-field col s12">
                          <select :id="'withRecord-'+name+'-'+index" v-model="task.withRecord" class="browser-default"> 
                          <option value="">No record</option>
                          <option v-for="[code, skill] in skills" :key="code" :value="code">
                              {{skill.name}}
                            </option>
                          </select>
                          <label :for="'withRecord-'+name+'-'+index" class="active">Record skill</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="input-field col s12">
                          <textarea :id="'instruction-'+name+'-'+index" v-model="task.instruction" class="browser-default" rows="5" />
                          <label :for="'instruction-'+name+'-'+index" class="active">Instruction</label>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="row">
                        <div class="col s3"><b>Task #{{index}}</b></div>
                        <div class="col s9">
                         
                            <a class="right" @click="removeTask(session, task)"><i class="material-icons">delete</i></a>

                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="row">
                  <div class="col s6">
                    <a class="btn left red" @click="removeSession(name)">REMOVE SESSION</a>
                  </div>
                  <div class="col s6">
                    <a class="btn right blue" @click="copySession(name)">COPY SESSION</a>
                  </div>
                </div>
            </div>
        </li>
    </ul>
  </div>
  <div class="row">
    <div class="col s4 left-align"> 
      <router-link class="waves-effect waves-light btn grey " :to="{ name: 'Coach', params:{tab:'programs'}}">Back
      </router-link>
    </div>
    <div class="col s4 center-align"> 
      <a class="waves-effect waves-light btn blue " @click="addSession()">Add
      </a>
    </div>
    <div class="col s4 center-align"> 
      <a class="waves-effect waves-light btn green " @click="save()">Save
      </a>
    </div>

  </div>
</div>
</template>

<script>
import M from 'materialize-css'
import api from '@/api'
import {arrayRemove, arrayMoveUp, arrayMoveDown} from '@/helpers/array'
import {cloneData} from '@/helpers/object'
export default {
  name: 'program',
  props: {
    programKey: String,
    user: Object
  },
  components: { },
  data: function () {
    return {
      program: undefined,
      taskTypes: [],
      skills: [],
      sessions: undefined,
      intensities: ['Low', 'Medium', 'High', 'Rest'],
      tabs: undefined
    }
  },
  computed: {
    // Sort numerically removing the W prefix
    sortedSessions () {
      return Object.entries(this.sessions).sort((v1, v2) => {
        const i1 = parseInt(v1[0].replace('W', ''))
        const i2 = parseInt(v2[0].replace('W', ''))
        if (i1 < i2) return -1
        if (i1 > i2) return 1
        if (i1 === i2) return 0
      })
    }
  },
  created () {
    this.program = api.getProgram(this.programKey)
    this.sessions = this.program.sessions
    this.taskTypes = api.getProgramTaskTypes()
    this.skills = Object.entries(api.getSkills())
  },
  mounted () {
    this.tabs = M.Tabs.init(this.$refs.tabs, {})
    M.Collapsible.init(this.$refs.collapsible, {})
  },
  methods: {
    onChangeSessionKey: function (oldKey, session, $event) {
      const newKey = $event.target.value
      this.sessions[newKey] = session
      delete this.sessions[oldKey]
      this.sessions = {...this.sessions} // refresh the object
    },
    insertTask (session, after) {
      session.tasks.splice(session.tasks.indexOf(after) + 1, 0, {
        type: undefined,
        title: 'New task',
        capTime: 5,
        instruction: ''
      })
    },
    removeTask (session, toRemove) {
      const i = session.tasks.indexOf(toRemove)
      session.tasks = arrayRemove(session.tasks, i)
    },
    moveTaskUp (session, task) {
      const i = session.tasks.indexOf(task)
      session.tasks = arrayMoveUp(session.tasks, i)
    },
    moveTaskDown (session, task) {
      const i = session.tasks.indexOf(task)
      session.tasks = arrayMoveDown(session.tasks, i)
    },
    addSession: function () {
      const n = Object.keys(this.sessions).length
      const newKey = 'W' + n
      const nSession = {}
      nSession[newKey] = {
        title: 'New session',
        tasks: [{
          index: 0,
          type: undefined,
          title: 'New task',
          capTime: undefined,
          instruction: undefined
        }]}
      this.sessions = Object.assign(nSession, this.sessions) // refresh the program object
      this.tabs.select('sessions')
    },
    copySession: function (name) {
      const n = Object.keys(this.sessions).length
      const newKey = 'W' + n
      const nSession = {}
      nSession[newKey] = cloneData(this.sessions[name])
      nSession[newKey].title = 'Copy of ' + this.sessions[name].title
      this.sessions = Object.assign(nSession, this.sessions)
    },
    removeSession: function (name) {
      delete this.sessions[name]
      this.sessions = {...this.sessions} // refresh the object
    },
    save: function () {
      this.program.sessions = this.sessions
      api.updateProgram(this.programKey, this.program)
      if (this.programKey !== this.program.name) {
        this.$events.$emit('programs-changed', {})
      }
      M.toast({html: 'Program saved'})
      this.$router.replace({ name: 'Coach', params: { tab: 'programs' } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/coach/ProgramEdit.vue